<section>
  <header class="sticky top-0 z-100">
    <app-mb-header />
  </header>
  <router-outlet></router-outlet>
  <app-mb-footer />
</section>
